/**
 * 基础色（Base Tokens）
 * 与 base-tokens.json 对应，供浅色/深色主题与语义层引用
 */
export type BaseTokens = {
  // --- 主题色 (Primary/Theme Colors) ---
  primary100: string;
  primary200: string;
  primary300: string;

  // --- 辅助色/中性色 (Neutral Colors)，对应 JSON「辅助色」--- 
  neutral100: string;
  neutral200: string;
  neutral300: string;
  neutral500: string;
  neutral600: string;
  neutral700: string;
  neutral800: string;

  // --- 辅助色/中性色-半透明 (Neutral Opacity)，对应 JSON「辅助色-半透明」---
  /** 辅助色-100 50% 透明度，对应「辅助色-100-50」 */
  neutral100A50: string;
  /** 辅助色-300 20% 透明度，对应「辅助色-300-20」 */
  neutral300A20: string;
  neutral800A25: string;
  neutral800A50: string;

  // --- 功能色 (Functional Colors)，对应 JSON「功能颜色」---
  error: string;
  success: string;
  info: string;
  sp1: string;
  sp2: string;
  sp3: string;
  sp4: string;
  sp5: string;
};

/** 浅色主题基础色（与 base-tokens.json Mode 1 一致） */
export const baseLight: BaseTokens = {
  // --- 主题色 ---
  primary100: '#50A1FF',
  primary200: '#E4E1FF',
  primary300: '#7468F0',

  // --- 辅助色/中性色 ---
  neutral100: '#FFFFFF',
  neutral200: '#EEEEEE',
  neutral300: '#978FE0',
  neutral500: '#525B86',
  neutral600: '#4C4E50',
  neutral700: '#363740',
  neutral800: '#1F2940',

  // --- 辅助色/中性色-半透明 ---
  neutral100A50: 'rgba(255, 255, 255, 0.5)',
  neutral300A20: 'rgba(151, 143, 224, 0.20)',
  neutral800A25: 'rgba(31, 41, 64, 0.25)',
  neutral800A50: 'rgba(31, 41, 64, 0.5)',

  // --- 功能色 ---
  error: '#FF5150',
  success: '#22BE70',
  info: '#FF8C00',
  sp1: '#FF8D80',
  sp2: '#FFD230',
  sp3: '#DD3330',
  sp4: '#FF7030',
  sp5: '#3F4D80',
};

/** 深色主题基础色（中性色反转以适配深色背景） */
export const baseDark: BaseTokens = {
  // --- 主题色 (与浅色一致) ---
  primary100: '#50A1FF',
  primary200: '#E4E1FF',
  primary300: '#7468F0',

  // --- 辅助色/中性色 (深色模式下 100 为亮色、800 为暗色) ---
  neutral100: '#E4E6F4',
  neutral200: '#C8CAE0',
  neutral300: '#978FE0',
  neutral500: '#525B86',
  neutral600: '#4C4E50',
  neutral700: '#363740',
  neutral800: '#1E1E2D',

  // --- 辅助色/中性色-半透明 ---
  neutral100A50: 'rgba(228, 230, 244, 0.5)',
  neutral300A20: 'rgba(151, 143, 224, 0.20)',
  neutral800A25: 'rgba(230, 230, 244, 0.1)',
  neutral800A50: 'rgba(230, 230, 244, 0.5)',

  // --- 功能色 (与浅色一致) ---
  error: '#FF5150',
  success: '#22BE70',
  info: '#FF8C00',
  sp1: '#FF8D80',
  sp2: '#FFD230',
  sp3: '#DD3330',
  sp4: '#FF7030',
  sp5: '#3F4D80',
};


/** 所有基础色 Token 的英文 Key 集合，与 BaseTokens 字段一致 */
export type BaseColorKeys =
  | 'primary100'
  | 'primary200'
  | 'primary300'
  | 'neutral100'
  | 'neutral200'
  | 'neutral300'
  | 'neutral500'
  | 'neutral600'
  | 'neutral700'
  | 'neutral800'
  | 'neutral100A50'
  | 'neutral300A20'
  | 'neutral800A25'
  | 'neutral800A50'
  | 'error'
  | 'success'
  | 'info'
  | 'sp1'
  | 'sp2'
  | 'sp3'
  | 'sp4'
  | 'sp5';


